module.exports = __webpack_public_path__ + "static/img/banner3.0df58aa6.png";